import L from 'leaflet';
import IconRed from './assets/map-marker-red.svg';
import IconOrange from './assets/map-marker-orange.svg';
import IconGreen from './assets/map-marker-green.svg';
import IconGray from './assets/map-marker-gray.svg';
import PpointIcon from './assets/ppoint.svg';
import TruckIcon from './assets/truck.svg';

export const IconMarkerGreen = L.icon({
  iconUrl: IconGreen,
  iconRetinaUrl: IconGreen,
  iconAnchor: L.point(15, 38),
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: [60, 50],
  className: 'Leaflet-venue-icon',
});
export const IconMarkerGray = L.icon({
  iconUrl: IconGray,
  iconRetinaUrl: IconGray,
  iconAnchor: L.point(15, 38),
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: [60, 50],
  className: 'Leaflet-venue-icon',
});
export const IconMarkerOrange = L.icon({
  iconUrl: IconOrange,
  iconRetinaUrl: IconOrange,
  iconAnchor: L.point(15, 38),
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: [60, 50],
  className: 'Leaflet-venue-icon',
});
export const IconMarkerRed = L.icon({
  iconUrl: IconRed,
  iconRetinaUrl: IconRed,
  iconAnchor: L.point(15, 38),
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: [60, 50],
  className: 'Leaflet-venue-icon',
});
export const PaqueryPointIconMarker = L.icon({
  iconUrl: PpointIcon,
  iconRetinaUrl: PpointIcon,
  iconAnchor: L.point(20, 25),
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: [35, 35],
  className: 'Leaflet-venue-icon',
});
export const TruckIconMarker = L.icon({
  iconUrl: TruckIcon,
  iconRetinaUrl: TruckIcon,
  iconAnchor: L.point(20, 25),
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: [35, 35],
  className: 'Leaflet-venue-icon',
});

export const CollectionIconMarker = L.divIcon({
  className: 'leaflet-collection-icon',
  iconSize: [30, 38],
  iconAnchor: L.point(15, 38),
  html: `<svg width="30" height="38" viewBox="0 0 30 38" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 37C15 37 28 23.5 28 14.5A13 13 0 1 0 2 14.5C2 23.5 15 37 15 37Z"
            fill="#389e0d" stroke="#ffffff" stroke-width="2"/>
      <path d="M9 11h12l1.4 3.6a2.4 2.4 0 0 1-4.7.6 2.4 2.4 0 0 1-4.7 0 2.4 2.4 0 0 1-4.7-.6L9 11Z
               M10 16.5V21h10v-4.5"
            fill="none" stroke="#ffffff" stroke-width="1.6" stroke-linejoin="round"/>
    </svg>`,
});
